import React, { useState, useEffect } from 'react';

const sections = [
  { id: 'innsamling', label: 'Datainnsamling', num: '01' },
  { id: 'formal', label: 'Formål med behandling', num: '02' },
  { id: 'sikkerhet', label: 'Lagring & Sikkerhet', num: '03' },
  { id: 'tredjepart', label: 'Tredjeparter', num: '04' },
  { id: 'rettigheter', label: 'Dine rettigheter', num: '05' },
  { id: 'informasjonskapsler', label: 'Informasjonskapsler', num: '06' },
  { id: 'oppbevaring', label: 'Oppbevaringstid', num: '07' },
  { id: 'internasjonalt', label: 'Internasjonale overføringer', num: '08' },
  { id: 'barn', label: 'Barns personvern', num: '09' },
  { id: 'kontakt', label: 'Kontakt oss', num: '10' },
];

const TableOfContents = () => {
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + 120;
      for (let i = sections?.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections?.[i]?.id);
        if (el && el?.offsetTop <= scrollPos) {
          setActiveId(sections?.[i]?.id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({ top: el?.offsetTop - 100, behavior: 'smooth' });
    }
  };

  return (
    <div
      style={{
        background: '#0A1220',
        border: '2px solid rgba(59,111,212,0.2)',
        padding: '32px',
        position: 'relative',
        transform: 'rotate(0.5deg)'
      }}
    >
      {/* Polaroid tape top */}
      <div
        style={{
          position: 'absolute',
          top: '-12px',
          left: '50%',
          transform: 'translateX(-50%) rotate(-2deg)',
          width: '60px',
          height: '24px',
          background: 'rgba(255,165,0,0.25)',
          border: '1px solid rgba(255,165,0,0.3)'
        }}
      />
      {/* Header */}
      <div style={{ marginBottom: '24px' }}>
        <div
          style={{
            fontFamily: 'Impact, sans-serif',
            fontSize: '0.75rem',
            color: '#F97316',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            marginBottom: '6px'
          }}
        >
          INNHOLDSFORTEGNELSE
        </div>
        <div
          style={{
            width: '40px',
            height: '3px',
            background: 'linear-gradient(90deg, #F97316, #3B6FD4)'
          }}
        />
      </div>
      {/* Links */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {sections?.map((section) => (
          <button
            key={section?.id}
            onClick={() => scrollTo(section?.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              background: activeId === section?.id ? 'rgba(59,111,212,0.12)' : 'transparent',
              border: 'none',
              borderLeft: activeId === section?.id ? '2px solid #3B6FD4' : '2px solid transparent',
              padding: '8px 10px',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'all 150ms ease',
              width: '100%'
            }}
            onMouseEnter={(e) => {
              if (activeId !== section?.id) {
                e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
                e.currentTarget.style.borderLeftColor = 'rgba(59,111,212,0.4)';
              }
            }}
            onMouseLeave={(e) => {
              if (activeId !== section?.id) {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.borderLeftColor = 'transparent';
              }
            }}
          >
            <span
              style={{
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '0.625rem',
                color: activeId === section?.id ? '#3B6FD4' : 'rgba(138,149,163,0.4)',
                letterSpacing: '0.1em',
                minWidth: '24px'
              }}
            >
              {section?.num}
            </span>
            <span
              style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.8125rem',
                color: activeId === section?.id ? '#EEF0F2' : 'rgba(138,149,163,0.7)',
                lineHeight: 1.4
              }}
            >
              {section?.label}
            </span>
          </button>
        ))}
      </div>
      {/* Bottom accent */}
      <div
        style={{
          marginTop: '24px',
          paddingTop: '16px',
          borderTop: '1px solid rgba(255,255,255,0.06)',
          fontFamily: 'JetBrains Mono, monospace',
          fontSize: '0.625rem',
          color: 'rgba(138,149,163,0.3)',
          letterSpacing: '0.08em'
        }}
      >
        NordPass AS · Personvernerklæring v2.1
      </div>
    </div>
  );
};

export default TableOfContents;
